import SurveysService from "@/services/SurveysService";
import AdministrationService from "@/services/AdministrationService";
import DashboardService from "@/services/DashboardService-APP_TARGET";
import EventBus from "@/services/EventBus";

export default {
  namespaced: true,

  state: {
    clients: [],
    structure: undefined,
    structures: [],
    isClientReady: false,
    appLoading: false,
    brandIds: [],
    countryCodes: [],
    filters: undefined,
  },

  getters: {
    appLoading: state => state.appLoading,
    clients: state => state.clients || [],
    brandIds: state => state.brandIds,
    countryCodes: state => state.countryCodes,
    filters: state => state.filters,
    isClientReady: state => state.isClientReady,
    project: state => {
      const firstChild = state.structure.children?.[0];
      return firstChild?.id?.startsWith('P') ? firstChild : null;
    },
    structure: state => state.structure,
    structures: state => state.structures,
    surveyIds: state => {
      if (!state.isClientReady || !state.structure) return [];
      if (state.structure.children[0]?.id.startsWith('P')) {
        if (!state.structure.children[0].children) return [];
        return state.structure.children[0].children.map(project => project.Survey.SurveyId);
      }
      return state.structure.children.map(survey => survey.Survey.SurveyId);
    },
  },

  mutations: {
    SET_BRANDIDS(state, brandIds) {
      state.brandIds = brandIds;
    },
    SET_CLIENTS(state, clients) {
      state.clients = clients;
      log.warn("CLIENTS: ", clients);
    },
    SET_COUNTRYCODES(state, countryCodes) {
      state.countryCodes = countryCodes;
    },
    SET_FILTERS(state, filters) {
      state.filters = filters;
    },
    SET_ISCLIENTREADY(state, isClientReady) {
      const wasReady = state.isClientReady;
      state.isClientReady = isClientReady;

      // Emit event when transitioning to ready
      if (!wasReady && isClientReady) {
        EventBus.$emit('app.ready');
      }
    },
    SET_APPLOADING(state, appLoading) {
      state.appLoading = appLoading;
    },
    SET_STRUCTURE(state, structure) {
      state.structure = structure;
    },
    SET_STRUCTURES(state, structures) {
      state.structures = structures;
    },
  },

  actions: {
    setAppLoading({ commit }, appLoading) {
      commit('SET_APPLOADING', appLoading);
    },
    async fetchClients({ commit }) {
      // log.warn("fetch clients");
      const result = await AdministrationService.getClientSettings(null);
      commit('SET_CLIENTS', result.data);
      commit('auth/SET_CLIENT_ID', result.data[0]?.ClientId, { root: true });
      commit('SET_ISCLIENTREADY', true);
    },

    async fetchStructure({ commit, state, rootGetters }) {
      if(state.structure && state.structure.id)
        return;

      const localizationId = rootGetters['auth/localizationId'];
      const clientId = rootGetters['auth/clientId'];
      const structures = await SurveysService.getSurveyStructure(
        localizationId, false, false);
      commit('SET_STRUCTURES', structures.data);

      commit('SET_STRUCTURE',
        structures.data.find(x => x.id === `C${clientId}`) || undefined);
    },

    async fetchFilters({ commit, state, rootGetters }) {
      const localizationId = rootGetters['auth/localizationId'];
      const clientId = rootGetters['auth/clientId'];

      let emptyFilters = await DashboardService.getOptions(
        { 'client': clientId }, null, localizationId);
      if (!emptyFilters || !emptyFilters.data || emptyFilters.data.length <= 0) {
        log.warn("NO Filters");
        return;
      }
      commit('SET_FILTERS', emptyFilters.data);
    }
  },
};
